<template>
    <div class="club-step__actions" v-if="actions">
        <button
            v-for="(action, index) in actions"
            :key="`action-${index}`"
            :class="action.className"
            @click="action.method"
            >
            {{ action.title }}
        </button>
    </div>
</template>
<script>
    export default {
        name: "Actions",
        props: {
            actions: {
                type: Array
            }
        }
    }
</script>
